function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#8B8B8B",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M21.65 9.697H18.01v-.516c0-.314-.128-.615-.355-.837A1.213 1.213 0 0 0 16.801 8h-3.533c-.663.001-1.2.53-1.201 1.181v.516H8.334a.331.331 0 0 0-.334.329c0 .18.15.328.334.328h1.41v10.548c0 .996.82 1.803 1.833 1.803h6.967c1.013 0 1.834-.807 1.834-1.803V10.356h1.265a.331.331 0 0 0 .333-.329.331.331 0 0 0-.333-.328l.007-.002zm-8.916-.516a.531.531 0 0 1 .534-.524H16.8a.531.531 0 0 1 .533.524v.516h-4.6v-.516zm6.984 11.724a1.16 1.16 0 0 1-1.168 1.15h-6.967a1.16 1.16 0 0 1-1.168-1.15V10.383h9.303v10.522z"
}), React.createElement("path", {
  d: "M14.982 21.087a.331.331 0 0 0 .334-.328v-8.997a.331.331 0 0 0-.334-.328.331.331 0 0 0-.334.328v8.997c0 .181.15.328.334.328zM12.705 20.103a.331.331 0 0 0 .333-.329V12.74a.331.331 0 0 0-.333-.328.331.331 0 0 0-.334.328v7.034c0 .182.15.329.334.329zM17.312 20.103a.331.331 0 0 0 .334-.329V12.74a.331.331 0 0 0-.334-.328.331.331 0 0 0-.334.328v7.034c0 .182.15.329.334.329z"
})), React.createElement("rect", {
  width: 29,
  height: 29,
  x: 0.5,
  y: 0.5,
  stroke: "#979797",
  rx: 4
}));

var SvgDeleteSquare = function SvgDeleteSquare(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDeleteSquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-square.99fd9250.svg";
export { ForwardRef as ReactComponent };